// removed by extract-text-webpack-plugin
module.exports = {"hero":"src-components-modules-ContentBlocks-Hero-style----general-module---hero---3F1U9"};


//////////////////
// WEBPACK FOOTER
// ./src/components/modules/ContentBlocks/Hero/style/general.module.css
// module id = 1441
// module chunks = 33019919093843